import React from 'react';
import {useState, useContext, useEffect} from 'react';
import { Container,Modal, ModalHeader, Input, Row, Button, Table, Badge, Spinner, Collapse, Card, CardHeader, CardBody, InputGroup} from 'reactstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content'
import { AppContext } from './AppContext';
import { TiPlus } from 'react-icons/ti';
import { IoIosTrash, IoMdCreate } from 'react-icons/io';

export const Competencias = (props) =>{
    const edoGlobal = useContext(AppContext);
    let [id,setId] = useState(0);
    let [tipo,setTipo] = useState(0);
    let [subTipo,setSubTipo] = useState(0);
    let [capturando, setCapturando] = useState(false);
    let [tipos, setTipos] = useState([]);
    let [subTipos, setSubTipos] = useState([]);
    let [competencias, setCompetencias] = useState([]);
    let [cargando, setCargando] = useState(false);

    useEffect(() => {
        (async () => {
            cargarTipos();
            cargarDatos();
            })();
    }, []);

    useEffect(() => {
        (async () => {
            subTipo = 0;
            cargarDatos();
            })();
    }, [tipo]);

    useEffect(() => {
        (async () => {
            cargarDatos();
            })();
    }, [subTipo]);

    async function cargarTipos(){
        setCargando(true);
        let url = `${edoGlobal.urlws}/programaIndicativo/tiposCompetencias`;
        let resp = await fetch(url);
        const t = await resp.json();
        setTipos(t);
        url = `${edoGlobal.urlws}/programaIndicativo/subTiposCompetencias?tipo=0`;
        resp = await fetch(url);
        const s = await resp.json();
        setCargando(false);
        setSubTipos(s);
    }

    async function cargarDatos(){
        setCargando(true);
        let url = `${edoGlobal.urlws}/programaIndicativo/competencias?tipo=${tipo}&subtipo=${subTipo}`;
        let resp = await fetch(url);
        const m = await resp.json();
        setCargando(false);
        setCompetencias(m);
    }
    async function nuevo() {
        if(tipo == 0){
            Swal.fire('Atencion', 'Debe especificar la categoría', 'error');
            return;
        }
        if(subTipo == 0){
            Swal.fire('Atencion', 'Debe especificar la sub categoría', 'error');
            return;
        }
        id = 0;        
        setId(0);
        const { value: texto } = await Swal.fire({
            input: 'textarea',
            inputValue: '',
            inputLabel: 'Nueva Competencia',
            inputPlaceholder: 'descripción de la competencia',
            confirmButtonText: 'aceptar',
            confirmButtonColor:'maroon'
        })
          
        if (texto) {
            guardar(texto);
        }
    }
    async function editar(i) {
        id = competencias[i].Id;
        setId(competencias[i].I);
        const { value: texto } = await Swal.fire({
            input: 'textarea',
            inputValue: competencias[i].Nombre,
            inputLabel: 'Editando competencia',
            inputPlaceholder: 'descripción de la competencia',
            confirmButtonText: 'aceptar',
            confirmButtonColor:'maroon'
        })
          
        if (texto) {
            guardar(texto);
        }
    }
    async function guardar(texto) {
        const dato = {
            Id: id, Texto : texto, Tipo : tipo, SubTipo : subTipo,
            Usuario : edoGlobal.usuario.Id 
        }
        let url = `${edoGlobal.urlws}/programaIndicativo/wsGuardarCompetencia`;
        setCargando(true);
        const json = JSON.stringify(dato);
        const resp = await fetch(url, {
            method: 'POST', // or 'PUT'
            body: json // data can be `string` or {object}!
        });
        const res = await resp.text();
        setCargando(false);
        if (res === "ok") {
            cargarDatos();
        }
        else
            Swal.fire('Atencion', res, 'error');
    }
    async function eliminar(o){
        const MySwal = withReactContent(Swal)
        MySwal.fire({
            title: 'Confirme',
            text: '¿ Desea eliminar "' + o.Nombre + '" ?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#1c4c01',
            cancelButtonColor: 'maroon',
            cancelButtonText: 'No',
            confirmButtonText: 'Si'
          }).then((result) => {
            if (result.value)
                eliminarB(o.Id);
        });
    }
    async function eliminarB(i){
        let url = `${edoGlobal.urlws}/programaIndicativo/eliminarCompetencia/${i}`;
        setCargando(true);
        const resp = await fetch(url);
        const res = await resp.text();
        setCargando(false);
        if (res === "ok") 
            cargarDatos();
        else
            Swal.fire('Atencion', res, 'error');     
    }
    return (
        <div>
            {cargando ?
                <div className="loader">
                    <Spinner animation="border" className='rojo' >&nbsp;</Spinner>
                </div>
                :
                null
            }
            <table>
                <thead>
                    <th>
                        <Input style={{ width: 200 }} type="select" value={tipo} onChange={(e) => setTipo(e.target.value)}>
                            <option value={0}>Todas</option>
                            {tipos.map((o, i) => <option key={i} value={o.I}>{o.N}</option>)}
                        </Input>
                    </th>
                    <th>
                        <Input style={{ width: 400 }} type="select" value={subTipo} onChange={(e) => setSubTipo(e.target.value)}>
                            <option value={0}>Todas</option>
                            {subTipos.filter((o) => o.D == tipo).map((o, i) => <option key={i} value={o.I}>{o.N}</option>)}
                        </Input>
                    </th>
                    <th><h4><Badge color='maroon' style={{ color: 'white', backgroundColor: 'maroon' }} >Competencias  <Badge color='white' size="sm" ><span style={{ color: 'maroon' }}>{competencias.length}</span></Badge> </Badge>  <span>&nbsp;&nbsp;&nbsp;</span><Button style={{ borderColor: 'maroon' }} size="sm" color="secondary" outline onClick={nuevo}><TiPlus size={20} color='maroon' title="nueva competencia" /><span className='negro'> Agregar competencia</span></Button></h4></th>
                </thead>
            </table>
            <Table size="sm" striped hover>
                <thead>
                    <tr>
                        <th>Categoría</th>
                        <th>Sub categoría</th>
                        <th>Competencia</th>
                        <th className='celdaBoton'></th>
                        <th className='celdaBoton'></th>
                   </tr>
                </thead>
                <tbody>
                    {competencias.map((o, i) =>
                        <tr key={i}>
                            <td>{o.NomTipo}</td>
                            <td>{o.NomSubTipo}</td>
                            <td onClick={() => editar(i)}>{o.Nombre}</td>
                            <td>
                                <IoMdCreate size={20} color='maroon' title="editar" onClick={() => editar(i)} />
                            </td>
                            <td>
                                <IoIosTrash size={20} color='maroon' title="eliminar" onClick={() => eliminar(o)} />
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
   )
}